import { Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { Observable, of, ReplaySubject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { ScrollspyNavItem } from '../../../elements/components/scrollspy-nav/entities/scrollspy-nav-item.entity';
import { Profile } from '../../profiles/entities/profile.entity';
import { ScrollService } from '../services/scroll.service';
import { BaseContainer } from './base.abstract.container';

@Component({
    selector: 'sh-scrollspy-nav-container',
    template: ''
})
export abstract class ScrollspyNavContainerComponent extends BaseContainer implements OnInit, OnDestroy {
    public scrollspyNavOffsetContainer$!: Observable<HTMLElement>;
    public scrollspyNavScrollContainer$!: Observable<HTMLElement | null>;
    public currentNavItems$: Observable<ScrollspyNavItem[]>;
    public readonly scrollspyNavItems$: ReplaySubject<ScrollspyNavItem[]> = new ReplaySubject<ScrollspyNavItem[]>(1);

    public showNoProfilesMsg: boolean;

    @ViewChild('stickyArea', { static: true }) stickyArea!: ElementRef;

    protected element: ElementRef = inject(ElementRef);
    protected scrollService: ScrollService = inject(ScrollService);

    ngOnInit(): void {
        this.setupScrollspyNav();
        const scrollContainer = this.element?.nativeElement.closest('.sh-scroll-container') || window;
        scrollContainer.addEventListener('scroll', () => {
            this.scrollService.triggerScrollEvent();
        });
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.scrollspyNavItems$.complete();
    }

    protected setupScrollspyNav(): void {
        this.scrollspyNavOffsetContainer$ = of(this.stickyArea?.nativeElement).pipe(takeUntil(this.destroy$));
        this.scrollspyNavScrollContainer$ = of(
            this.element.nativeElement.closest('.sh-scroll-container') || this.element.nativeElement
        ).pipe(takeUntil(this.destroy$));
        this.currentNavItems$ = this.scrollspyNavItems$.pipe(debounceTime(1), takeUntil(this.destroy$));
    }

    public receiveProfiles(profiles: Profile[]): void {
        this.showNoProfilesMsg = profiles.length === 0;

        this.scrollspyNavItems$.next(
            profiles.map(profile => ({
                label: profile.Name,
                target: profile.Id
            }))
        );
    }
}
